let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fXI14")).then(() => parcelRequire('6TPcn'));